import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import GalleryLifeStyle from './GalleryLifeStyle';
import Ceo from '../../assets/images/ceo.jpg';
import SERV from '../../assets/images/service1.jpg';
import { motion } from 'framer-motion'; // Importation de Framer Motion

const ServicePage = () => {
  return (
    <section id="main-container" className="main-container" style={{ backgroundImage: 'url(images/assets/ban4.jpg)' }}>
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-4">
            <div className="sidebar sidebar-left">
              <div className="widget">
                <h3 className="widget-title">Solutions</h3>
                <ul className="nav service-menu">
                  <li className="active"><Link to="/Securite-residentielle-industrielle">Sécurité résidentielle et industrielle</Link></li>
                  <li><Link to="/Protection-rapprochee">Protection rapprochée</Link></li>
                  <li><Link to="/Surveillance-de-sites-minierse">Surveillance de sites miniers</Link></li>
                  <li><Link to="/Transport-securise">Transport sécurisé</Link></li>
                 
                </ul>
              </div>

              <div className="widget">
                <div className="quote-item quote-border">
                  <div className="quote-text-border">
                   L’excellence au service de votre protection. 
                  </div>
                  <div className="quote-item-footer">
                    <img className="testimonial-thumb" src={Ceo} alt="testimonial" />
                    <div className="quote-item-info">
                      <h3 className="quote-author text-dark">Kanku Kalala Pierre</h3>
                      <span className="quote-subtext">Administrateur Général <br /> et Associé Unique</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-8 col-lg-8">
            <div className="content-inner-page">
              {/* Titre avec animation */}
              <motion.h2
                className="column-title mrt-0 fw-bold"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
              >
               Sécurité résidentielle et industrielle
              </motion.h2>

              <div className="row">
                 <div className="col-md-12">
                  <div className="card mb-4" >
  <img src={SERV} className="card-img-top img-fluid hover-shadow" alt="Sunset Over the Sea"/>
 
</div>
                 </div>
                <div className="col-md-12">
                  {/* Paragraphe animé */}
                  <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 1 }}
                  >
                   GEKAS Security and Consulting SARL propose un service de sécurité résidentielle et industrielle conçu pour offrir une protection optimale aux habitations privées, aux immeubles résidentiels ainsi qu’aux installations industrielles sensibles. Conscients des enjeux croissants liés à l’insécurité, nous mettons à disposition des agents hautement qualifiés, formés pour prévenir les intrusions, détecter les comportements suspects et intervenir rapidement en cas d’incident.
                  </motion.p>
                  <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                  >
                  Notre approche repose sur une analyse rigoureuse des besoins spécifiques de chaque site. Pour les résidences, nous assurons une surveillance discrète mais efficace, garantissant la tranquillité d’esprit des familles et résidents. Pour les zones industrielles, souvent confrontées à des risques plus complexes (vandalisme, sabotage, vol de matériel), nous proposons des dispositifs technologiques avancés tels que des systèmes de vidéosurveillance, des alarmes intelligentes et des patrouilles régulières.
                  </motion.p>

                   <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                  >
                 Chez GEKAS, la sécurité n’est pas une simple prestation : c’est un engagement. Nous collaborons étroitement avec nos clients pour établir des protocoles sur mesure, en conformité avec les normes nationales de sûreté. Grâce à notre savoir-faire et à notre professionnalisme, nous contribuons activement à créer des environnements sûrs, stables et propices à la prospérité, tant pour les familles que pour les entreprises.
                  </motion.p>
                </div>
              </div>

              <div className="gap-40"></div>

       

              <div className="gap-40"></div>

         

              <div className="gap-40"></div>

              {/* Call to Action avec animation sur le bouton */}
              <div className="call-to-action classic">
                <div className="row align-items-center">
                  <div className="col-md-8 text-center text-md-left">
                    <div className="call-to-action-text">
                      <h4 className="action-title">Êtes-vous intéressé par ce service ?</h4>
                    </div>
                  </div>
                  <div className="col-md-4 text-center text-md-right mt-3 mt-md-0">
                    <motion.div
                      className="call-to-action-btn"
                      whileHover={{ scale: 1.1, color: '#ffffff', backgroundColor: '#ff9800' }}
                    >
                      <Link to="/Contact" className="btn btn-warning">
                        Contactez-nous
                      </Link>
                    </motion.div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ServicePage;
